// init AOS
function initProgressNumbers(id){
    var idElement = $(id).attr('id');
    var ini = $(id).attr('data-init');
    var end = $(id).attr('data-end');
    var temp = $(id).attr('data-temp');
   if(!$(id).hasClass('initialized')){
       animacaoNumero(idElement, parseInt(ini), parseInt(end), parseInt(temp));
       $(id).addClass('initialized');
   }
    //console.log(idElement + ' -- ' + ini + ' -- ' + end + ' -- ' + temp);
}

function animacaoNumero(id, inicio, final, duracao) {

    var obj = document.getElementById(id);
    var range = final - inicio;
    var minTimer = 50;
    var stepTime = Math.abs(Math.floor(duracao / range));

    stepTime = Math.max(stepTime, minTimer);

    var startTime = new Date().getTime();
    var endTime = startTime + duracao;
    var timer;

    function run() {
        var now = new Date().getTime();
        var remaining = Math.max((endTime - now) / duracao, 0);
        var value = number_format(Math.round(final - (remaining * range)), 0, '', '.');
        obj.innerHTML = value;
        if (value === final) {
            clearInterval(timer);
        }
    }

    var timer = setInterval(run, stepTime);
    run();
}

function number_format(number, decimals, dec_point, thousands_sep) {

    number = (number + '')
        .replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k)
                .toFixed(prec);
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
        .split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '')
        .length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1)
            .join('0');
    }
    return s.join(dec);
}

if (is.not.ie()) {
    AOS.init();

    document.addEventListener('aos:in:num-peso', ({ detail }) => {
        //console.log('animated in', detail);
        initProgressNumbers('#num-peso-progress');
    });

    document.addEventListener('aos:in:num-embalagens', ({ detail }) => {
        console.log('entrou', detail);
        initProgressNumbers('#num-embalagens-progress');
    });

    $('.foneMask').focusout(function () {
        var phone, element;
        element = $(this);
        element.unmask();
        phone = element.val().replace(/\D/g, '');
        if (phone.length > 10) {
            element.mask("(99) 99999-999?9");
        } else {
            element.mask("(99) 9999-9999?9");
        }
    }).trigger('focusout');


} else {
    $('*').removeAttr("data-aos");
}

function validarEntrada() {
    var valorAtual = $(this).val();
    var textoFiltrado = valorAtual.replace(/[^0-9()\- ]/g, '');
    if (valorAtual !== textoFiltrado) {
        $(this).val(textoFiltrado); // Atualiza o campo com o texto filtrado
    }
}

$('.phoneNumber').on('paste', function(e) {
    // Captura o conteúdo que está sendo colado
    var textoColado = e.originalEvent.clipboardData.getData('text');
    // Filtra apenas os caracteres permitidos
    var textoFiltrado = textoColado.replace(/[^0-9()\- ]/g, '');
    // Define o valor do campo com o texto filtrado
    var posicaoCursor = this.selectionStart;
    var valorAtual = $(this).val();

    // Atualiza o valor do campo de texto
    $(this).val(valorAtual.slice(0, posicaoCursor) + textoFiltrado + valorAtual.slice(posicaoCursor));
    e.preventDefault(); // Impede o comportamento padrão de colar
});

$('.phoneNumber').on('input', validarEntrada);

$("#formContato").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            //target: 'status-envio',
            beforeSubmit: function () {
                $('#status-envio').show();
                $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                $('#btnContato').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                if(parseInt(result[1]) == 1){
                    $('#status-envio').html(result[2]);
                    setTimeout(function(){
                        $('#btnContato').attr('disabled',false);
                        $("#formContato .field").val('');
                        $("#formContato textarea").val('').html('');
                        $("#formContato .field").removeClass('error');
                        $('#status-envio').hide();
                        $('#status-envio').empty();
                    },2000);
                }else{
                    $('#status-envio').html(result[2]);
                    setTimeout(function () {
                        $('#status-envio').hide();
                        $('#status-envio').empty();
                        $('#btnContato').attr('disabled', false);
                    }, 3000);
                }
            }
        });
    }
});

if ($('.mySwiper').length) {
    new Swiper('.mySwiper', {
        slidesPerView: 7, 
        spaceBetween: 20, 
        loop: false
    });
}

if ($('.swiper-overview').length) {
    const swiperTabsOverview = new Swiper(".swiper-overview", { 
        slidesPerView: 1,
        spaceBetween: 0,
        hashNavigation: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });
    swiperTabsOverview.on('slideChange', function (e) {
        var i = swiperTabsOverview.activeIndex;
        $('.c-tabs__head a').removeClass('is-active');
        $('[data-to=' + i + ']').addClass('is-active');
    });

    const swiper11 = new Swiper(".mySwiper", {
        slidesPerView: 7, 
        spaceBetween: 20, 
        freeMode: true, 
        hashNavigation: false,
        breakpoints: {
            // when window width is >= 320px
            320: {
            slidesPerView: 1.5
            },
            // when window width is >= 490px
            490: {
            slidesPerView: 2.5
            },
            // when window width is >= 640px
            640: {
            slidesPerView: 3.5
            },
            // when window width is >= 790px
            790: {
            slidesPerView: 4.5
            },
            // when window width is >= 990px
            990: {
            slidesPerView: 5.5
            },
            // when window width is >= 1024px
            1024: {
            slidesPerView: 6.5
            }
        }
    });

    swiperTabsOverview.controller.control = swiper11;
    swiper11.controller.control = swiperTabsOverview; 

    $('.c-tabs__head a').on('click', function (e) {
        e.preventDefault();

        $('.c-tabs__head a').removeClass('is-active');
        $(this).addClass('is-active');

        var p = $(this).attr('data-to');
        swiperTabsOverview.slideTo(p);
        $('.c-tabs__head a').removeClass('is-active');
        $(this).addClass('is-active');
    });
    
}

//  float elements
$('.u-maxRow').enllax();

if ($('.yt-player').length) {

    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function onYouTubeIframeAPIReady() {
        // Check all slides and initialize video players
        var videos = document.getElementsByClassName('yt-player')

        var players = [];

        for (var i=0; i < videos.length; i++) {
            var id = videos[i].getAttribute('data-id');

            var player = new YT.Player(videos[i], {
                height: '100%',
                width: '100%',
                videoId: id,
                playerVars: {
                    autoplay: false,
                    mute: 0,
                    controls: 0,
                    showinfo: 0,
                    loop: 1,
                    playlist:id,
                    color: '#7fbc03',
                    modestbranding: true,
                    rel: 0
                },
                events: {
                    //'onReady': adjusteIframe,
                    //   'onStateChange': onPlayerStateChange
                }
            });
            players.push(player);
        }
    }
}





function closeAllSubMenus() {
    $('.c-subMenu').removeClass('is-active');
}
function closeResponsiveMenu() {
    propsNav.hamburguer.removeClass(propsNav.active);
    propsNav.contentHero.removeClass(propsNav.active);
}
function hideMaskMenu() {
    propsNav.mask.removeClass(propsNav.active);
}
function disableOverflow() {
    propsNav.body.addClass('u-overflowBlocked');
}
function enableOverflow() {
    propsNav.body.removeClass('u-overflowBlocked');
}


if ($('.l-nav').length) {
    var propsNav = {
        active: 'is-active',
        scrollInit: 0,
        scrollClassScrolled: 99,
        scrollClassMiddle: 600,
        body: $('body'),
        nav: $('.l-nav'),
        hamburguer: $('.l-nav .c-hamburguer'),
        contentHero: $('.l-nav__contentHero'),
        mask: $('.l-nav__maskMenu'),
        maskAll: $('.l-nav__maskMenu.maskAll'),
    };

    function checkResponsiveMode() {
        var resultCheck;
        var displayCheck = propsNav.hamburguer.css('display');
        if (displayCheck !== 'none') {
            resultCheck = 'is-responsive';
            propsNav.nav.removeClass('is-desktop');
            propsNav.nav.addClass('is-responsive');
        } else {
            resultCheck = 'is-desktop';
            propsNav.nav.removeClass('is-responsive');
            propsNav.nav.addClass('is-desktop');
        }
        return resultCheck;
    }
    function closeAllSubMenus() {
        $('.c-subMenu').removeClass('is-active');
    }
    function closeResponsiveMenu() {
        propsNav.hamburguer.removeClass(propsNav.active);
        propsNav.contentHero.removeClass(propsNav.active);
    }
    function hideMaskMenu() {
        propsNav.mask.removeClass(propsNav.active);
    }
    function disableOverflow() {
        propsNav.body.addClass('u-overflowBlocked');
    }
    function enableOverflow() {
        propsNav.body.removeClass('u-overflowBlocked');
    }


    // RESPONSIVE MENU
    // - open / close
    propsNav.hamburguer.on('click', function() {
        if ($(this).hasClass(propsNav.active)) {
            // close menu
            enableOverflow();
            $(this).removeClass(propsNav.active);
            propsNav.maskAll.removeClass(propsNav.active);
            propsNav.contentHero.removeClass(propsNav.active);
        } else {
            // open menu
            disableOverflow();
            $(this).addClass(propsNav.active);
            propsNav.maskAll.addClass(propsNav.active);
            propsNav.contentHero.addClass(propsNav.active);
        }
    });
    // - close
    propsNav.maskAll.on('click', function(){
        closeResponsiveMenu();
        hideMaskMenu();
        closeAllSubMenus();
        enableOverflow();
    });

    // RESPONSIVE MODE
    $(window).on('resize', function() {
        if (checkResponsiveMode() === "is-desktop") {
            if (propsNav.contentHero.hasClass(propsNav.active)) {
                closeAllSubMenus();
                closeResponsiveMenu();
                hideMaskMenu();
            }
        }
    });

    // SCROLL CHANGES
    $(window).on('load', function(event) {
        checkResponsiveMode();
        var scrollBody = $(this).scrollTop();
        if (scrollBody > 1) {
            propsNav.nav.addClass('scrolled');
        } else {
            propsNav.nav.removeClass('scrolled');
        }
    });
    $(window).on('scroll', function() {
        var scrollBody = $(this).scrollTop();
        // scroll up to 99
        if (scrollBody > propsNav.scrollClassScrolled) {
            propsNav.nav.addClass('scrolled');
        } else {
            propsNav.nav.removeClass('scrolled');
        }
        // middle class
        if (scrollBody > propsNav.scrollClassMiddle) {
            propsNav.nav.addClass('hidden');
            propsNav.nav.addClass('scrolledMiddle');
        } else {
            propsNav.nav.removeClass('hidden');
            propsNav.nav.removeClass('scrolledMiddle');
        }
        // scroll up or down
        if (scrollBody < propsNav.scrollInit) {
            propsNav.nav.removeClass('hidden');
            propsNav.nav.addClass('scrolledUp');
            propsNav.nav.removeClass('scrolledDown');
        } else {
            propsNav.nav.removeClass('scrolledUp');
            propsNav.nav.addClass('scrolledDown');
        }
        // close menus on hidden nav
        if(propsNav.nav.hasClass('hidden')) {
            closeAllSubMenus();
            hideMaskMenu();
        }
        // reference var
        propsNav.scrollInit = scrollBody;
    });
}

$('.js-smoothLink').on('click', function(e) {
    closeAllSubMenus();
    closeResponsiveMenu();
    hideMaskMenu();
    enableOverflow();

    e.preventDefault();
    var finalDestiny = $(this).attr('href');
    goToSection__scroll(finalDestiny, 115, 115, 700, 10);
});

$('.js-scrollLink').on('click', function(e) {
    e.preventDefault();
    var finalDestiny = $(this).attr('href');
    goToSection__scroll(finalDestiny, 115, 115, 700, 10);
});


function goToSection__scroll(elScrollDestiny, distanceIfScrollGoingToUp, distanceIfScrollGoingToDown, speedScroll, delay) {
    console.clear();
    // scroll reference
    var scrollEfetuado = $(window).scrollTop();
    console.log(scrollEfetuado);
    // element reference
    var sectionDestiny_offsetTop = $(elScrollDestiny).offset().top;
    console.log(elScrollDestiny);
    console.log(sectionDestiny_offsetTop);

    if (scrollEfetuado > sectionDestiny_offsetTop) {
        console.log('vai subir');
        setTimeout(function(){
            $('html, body').animate({
                scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToUp
            }, speedScroll);
        }, delay);
    } else {
        console.log('vai descer');
        setTimeout(function(){
            $('html, body').animate({
                scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToDown
            }, speedScroll);
        }, delay);
    }
}

function onScroll(event){
    var scrollPos = $(document).scrollTop();
    var heights = [];
    $('.l-nav__indexSections a').each(function () {
        var thisElement = $(this);
        var refElement = $(thisElement.attr("href"));
        heights.push(refElement.offset().top);
    });
    if (scrollPos >= 0) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link0').addClass('is-active');
    }
    if (scrollPos > (heights[1] - 130)) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link1').addClass('is-active');
    }
    if (scrollPos > (heights[2] - 130)) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link2').addClass('is-active');
    }
    if (scrollPos > (heights[3] - 130)) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link3').addClass('is-active');
    }
    if (scrollPos > (heights[4] - 130)) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link4').addClass('is-active');
    }
    if (scrollPos > (heights[5] - 130)) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link5').addClass('is-active');
    }
    if (scrollPos > (heights[6] - 130)) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link6').addClass('is-active');
    }
    if (scrollPos > (heights[7] - 300)) {
        $('.js-smoothLink').removeClass('is-active');
        $('.js-smoothLink.--link7').addClass('is-active');
    }
    console.log(scrollPos + ' ---- ' + (heights[5]));
}

var v = document.getElementById('videoBg');

$('body').on('click', '.playVideo', function() {
    //v.play();
    if (v.paused) {
        v.play();
        //v.controls=true;
        $(this).css('opacity', 0);
    } else {
        v.pause();
        //v.controls="";
        $(this).css('opacity', 1);
    }
})
